// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_35-1";
export var rateTableServiceLevelDropdown = "_35-3";
export var rateTableTypeDropdown = "_35-0";
export var rateTableValueModeDropdown = "_35-2";